import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class PageSizeOptions extends PureComponent {
  handlePageSizeChange = e =>
    this.props.onPageSizeChange(Number(e.target.value));

  render() {
    const {
      pageSize,
      pageSizeOptions,
      rowsSelectorText,
      rowsText,
    } = this.props;

    return (
      <span className="select-wrap -pageSizeOptions">
        {rowsSelectorText}
        <select
          aria-label={rowsSelectorText}
          value={pageSize}
          onChange={this.handlePageSizeChange}
        >
          {pageSizeOptions.map((option, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <option key={i} value={option}>
              {`${option} ${rowsText}`}
            </option>
          ))}
        </select>
      </span>
    );
  }
}

PageSizeOptions.defaultProps = {
  onPageSizeChange: () => {},
};

PageSizeOptions.propTypes = {
  pageSize: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.array.isRequired,
  rowsSelectorText: PropTypes.string.isRequired,
  rowsText: PropTypes.string.isRequired,
  onPageSizeChange: PropTypes.func,
};

export default PageSizeOptions;
